import React, {
    useEffect,
    useLayoutEffect,
    useRef,
    useState
  } from "react";
  import { db } from "../firebase";
  
  import {
    collection,
    getDocs,
    updateDoc,
    deleteDoc,
    deleteField,
    doc,
    query,
    where,
  } from "firebase/firestore";
  import OtherBetNavbarBottom from "../Components/OtherBetNavbarBottom";
  import "./AdminBetsRequest.css";
  
  export default function AdminViewBetHistory() {
    const [bets, setBets] = useState([]);
    const tableRef = useRef(null);
    const [loading, setLoading] = useState(true);
    const [searchMatch, setSearchMatch] = useState("");
    const [dateFilter, setDateFilter] = useState("today");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [message, setMessage] = useState("");
  
    const fieldMap = {
      TZS: "tshBalance",
      USDT: "usdtBalance",
      KES: "KESBalance",
      UGX: "UGXBalance",
      RWF: "RWFBalance",
      BIF: "BIFBalance",
      ZMW: "ZMWBalance",
      MWK: "MWKBalance",
      MZN: "MZNBalance",
      USD: "USDBalance",
      SSP: "SSPBalance",
      BWP: "BWPBalance",
      MGA: "MGABalance",
    };
  
    useEffect(() => {
      fetchBets();
    }, []);
    
    useLayoutEffect(() => {
      if (tableRef.current) {
        tableRef.current.scrollLeft = 0;
      }
    }, [bets]);
    async function fetchBets() {
      setLoading(true);
  
      try {
        const snap = await getDocs(
          collection(db, "antscore")
        );
  
        const list = snap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));
  
        setBets(list);
  
       
  
        
      } catch (error) {
        console.error(error);
        showMessage("Failed to load bets ❌");
      } finally {
        setLoading(false);
      }
    }
  
    const showMessage = (msg) => {
      setMessage(msg);
  
      setTimeout(() => {
        setMessage("");
      }, 3000);
    };
  
    const formatDateTime = (timestamp) => {
      if (!timestamp) return "-";
  
      const date = timestamp.toDate
        ? timestamp.toDate()
        : new Date(timestamp);
  
      if (isNaN(date.getTime())) return "-";
  
      return date.toLocaleString();
    };
  
    const getMatchDate = (bet) => {
      if (bet.matchTimestamp?.toDate) {
        return bet.matchTimestamp.toDate();
      }
  
      if (bet.matchTimestamp) {
        const d = new Date(bet.matchTimestamp);
  
        if (!isNaN(d.getTime())) {
          return d;
        }
      }
  
      if (bet.matchDate && bet.matchTime) {
        const d = new Date(
          `${bet.matchDate}T${bet.matchTime}`
        );
  
        if (!isNaN(d.getTime())) {
          return d;
        }
      }
  
      return null;
    };
  
    const isPastMatch = (bet) => {
      const date = getMatchDate(bet);
  
      if (!date) return false;
  
      return date < new Date();
    };
  
  
    async function toggleBlock(bet) {
      try {
        await updateDoc(
          doc(db, "antscore", bet.id),
          {
            blockedPayout: !bet.blockedPayout,
          }
        );
    
        showMessage(
          bet.blockedPayout
            ? "✅ User unblocked"
            : "🚫 User blocked from payout"
        );
    
        fetchBets();
      } catch (err) {
        console.error(err);
        showMessage("Failed to update block ❌");
      }
    }
  
  
    async function handleWonBet(bet) {
      if (bet.blockedPayout) {
        showMessage(
          "🚫 User huyu ame-blockiwa payout"
        );
        return;
      }
  
      if (bet.paidOut === true) {
        showMessage("⚠️ Tayari imelipwa");
        return;
      }
  
      if (bet.result) {
        showMessage(
          "⚠️ Bet hii tayari ina result"
        );
        return;
      }
  
      try {
        const q = query(
          collection(db, "users"),
          where("username", "==", bet.username)
        );
  
        const snap = await getDocs(q);
  
        if (snap.empty) {
          showMessage("User not found ❌");
          return;
        }
       
        const userDoc = snap.docs[0];
  
        const userRef = doc(
          db,
          "users",
          userDoc.id
        );
  
        const userData = userDoc.data();
  
        const field = fieldMap[bet.currency];
  
        if (!field) {
          showMessage(
            "Currency field not found ❌"
          );
          return;
        }
  
        const payout = Number(
          bet.totalWin || 0
        );
  
        const currentBalance = Number(
          userData[field] || 0
        );
  
        await updateDoc(userRef, {
          [field]:
            currentBalance + payout,
        });
  
        await updateDoc(
          doc(
            db,
            "antscore",
            bet.id
          ),
          {
            result: "win",
            paidOut: true,
            paidAt: new Date(),
            forceByAdmin:
              !isPastMatch(bet),
          }
        );
  
        showMessage(
          `✅ ${bet.username} amelipwa ${payout}`
        );
  
        fetchBets();
      } catch (err) {
        console.error(err);
        showMessage("Error ❌");
      }
    }
  
    async function handleLost(bet) {
      if (bet.result) {
        showMessage(
          "⚠️ Bet hii tayari ina result"
        );
        return;
      }
  
      try {
        await updateDoc(
          doc(
            db,
            "antscore",
            bet.id
          ),
          {
            result: "lose",
            paidOut: false,
            lostAt: new Date(),
            forceByAdmin:
              !isPastMatch(bet),
          }
        );
  
        showMessage(
          `❌ ${bet.username} bet imewekwa LOST`
        );
  
        fetchBets();
      } catch (err) {
        console.error(err);
        showMessage(
          "Failed to mark lost ❌"
        );
      }
    }
  
    // Rejesha bets zilizo-markiwa LOST kurudi PENDING.
    // Hii ni action ya makusudi; All Won/All Lost hazibadilishi bets zenye result tayari.
    async function restoreLostToPending() {
      const lostBets = bets.filter((bet) => bet.result === "lose");
  
      if (lostBets.length === 0) {
        showMessage("⚠️ Hakuna bet za LOST za kurejesha");
        return;
      }
  
      const confirmed = window.confirm(
        `Unataka kurejesha bets ${lostBets.length} kutoka LOST kwenda PENDING?`
      );
      if (!confirmed) return;
  
      try {
        for (const bet of lostBets) {
          await updateDoc(doc(db, "antscore", bet.id), {
            result: deleteField(),
            paidOut: false,
            lostAt: deleteField(),
            paidAt: deleteField(),
            forceByAdmin: deleteField(),
          });
        }
  
        showMessage(`✅ Bets ${lostBets.length} zimerudishwa PENDING`);
        await fetchBets();
      } catch (err) {
        console.error(err);
        showMessage("Imeshindikana kurejesha bets ❌");
      }
    }
  
    async function deleteBet(bet) {
      try {
        await deleteDoc(
          doc(
            db,
            "antscore",
            bet.id
          )
        );
  
        showMessage("Bet deleted ✅");
  
        fetchBets();
      } catch (err) {
        console.error(err);
        showMessage(
          "Failed to delete ❌"
        );
      }
    }
  
    async function handleAllWon() {
      const pendingPast = bets.filter(
        (b) =>
          !b.result &&
          isPastMatch(b) &&
          !b.blockedPayout
      );
  
      if (pendingPast.length === 0) {
        showMessage(
          "⚠️ Hakuna bet iliyomaliza muda"
        );
        return;
      }
  
      for (let bet of pendingPast) {
        await handleWonBet(bet);
      }
  
      showMessage(
        `✅ ${pendingPast.length} bets zimelipwa`
      );
    }
  
    async function handleAllLost() {
      const pendingPast = bets.filter(
        (b) =>
          !b.result &&
          isPastMatch(b) &&
          !b.blockedPayout
      );
  
      if (pendingPast.length === 0) {
        showMessage(
          "⚠️ Hakuna bet iliyomaliza muda wa kuweka LOST"
        );
        return;
      }
  
      try {
        for (let bet of pendingPast) {
          await updateDoc(
            doc(
              db,
              "antscore",
              bet.id
            ),
            {
              result: "lose",
              paidOut: false,
              lostAt: new Date(),
              forceByAdmin: false,
            }
          );
        }
  
        showMessage(
          `❌ ${pendingPast.length} bets zimewekwa LOST`
        );
  
        fetchBets();
      } catch (err) {
        console.error(err);
        showMessage(
          "Failed to mark all lost ❌"
        );
      }
    }
  
    const getBetCreatedDate = (bet) => {
      const value = bet.createdAt || bet.betTimestamp || bet.timestamp || bet.date;
      if (!value) return null;
      const date = value?.toDate ? value.toDate() : new Date(value);
      return Number.isNaN(date.getTime()) ? null : date;
    };
  
    const isWithinSelectedPeriod = (bet) => {
      if (dateFilter === "all") return true;
      const created = getBetCreatedDate(bet);
      if (!created) return false;
  
      const now = new Date();
      const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
      const today = startOfDay(now);
  
      if (dateFilter === "today") return created >= today && created < new Date(today.getTime() + 86400000);
      if (dateFilter === "yesterday") {
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        return created >= yesterday && created < today;
      }
      if (dateFilter === "week") {
        const monday = new Date(today);
        const day = (monday.getDay() + 6) % 7;
        monday.setDate(monday.getDate() - day);
        return created >= monday && created < new Date(today.getTime() + 86400000);
      }
      if (dateFilter === "custom") {
        if (!startDate && !endDate) return true;
        const start = startDate ? new Date(`${startDate}T00:00:00`) : null;
        const end = endDate ? new Date(`${endDate}T23:59:59.999`) : null;
        return (!start || created >= start) && (!end || created <= end);
      }
      return true;
    };
  
    const filtered = bets
      .filter((bet) =>
        `${bet.teamA || ""} ${bet.teamB || ""} ${bet.username || ""} ${bet.betId || ""}`
          .toLowerCase()
          .includes(searchMatch.trim().toLowerCase())
      )
      .filter(isWithinSelectedPeriod)
      .sort((a, b) => {
        const dateA = getBetCreatedDate(a)?.getTime() || 0;
        const dateB = getBetCreatedDate(b)?.getTime() || 0;
        return dateB - dateA;
      });
  
    // ===== STATS =====
  
    const totalPlayers = filtered.length;
  
    const totalAmount = filtered.reduce(
      (sum, bet) =>
        sum + Number(bet.amount || 0),
      0
    );
  
    const totalPossibleWin =
      filtered.reduce(
        (sum, bet) =>
          sum + Number(bet.totalWin || 0),
        0
      );
  
    const endedMatches = filtered.filter(
      (bet) => isPastMatch(bet)
    ).length;
  
    const scoreStats = {};
  
    filtered.forEach((bet) => {
      const score =
        bet.score || "No Score";
  
      if (!scoreStats[score]) {
        scoreStats[score] = 0;
      }
  
      scoreStats[score]++;
    });
  
  return (
    
    <div className="page-container admin-ant-container">
      <OtherBetNavbarBottom/>
        <h2>
          Admin Bets (AntScore Only)
        </h2>
  
        <input
          placeholder="Search match / user"
          value={searchMatch}
          onChange={(e) =>
            setSearchMatch(
              e.target.value
            )
          }
        />
        <div className="bet-history-filters" style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 12, alignItems: "center" }}>
          <label>
            Kipindi:{" "}
            <select value={dateFilter} onChange={(e) => setDateFilter(e.target.value)}>
              <option value="today">Today / Leo</option>
              <option value="yesterday">Yesterday / Jana</option>
              <option value="week">This week / Wiki hii</option>
              <option value="custom">Custom dates / Tarehe maalum</option>
              <option value="all">All time / Muda wote</option>
            </select>
          </label>
          {dateFilter === "custom" && (
            <>
              <label>Kuanzia: <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></label>
              <label>Mpaka: <input type="date" value={endDate} min={startDate || undefined} onChange={(e) => setEndDate(e.target.value)} /></label>
            </>
          )}
          <button type="button" onClick={() => { setSearchMatch(""); setDateFilter("today"); setStartDate(""); setEndDate(""); }}>
            Reset filters
          </button>
        </div>
  
        {message && (
          <p className="admin-message">
            {message}
          </p>
        )}
  
        {/* ===== SUMMARY SECTION ===== */}
  
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(220px,1fr))",
            gap: "15px",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <div className="summary-card">
            <h3>Total Bets</h3>
            <p>{totalPlayers}</p>
          </div>
  
          <div className="summary-card">
            <h3>Total Amount</h3>
            <p>
              {totalAmount.toLocaleString()}
            </p>
          </div>
  
          <div className="summary-card">
            <h3>Total Possible Win</h3>
            <p>
              {totalPossibleWin.toLocaleString()}
            </p>
          </div>
  
          <div className="summary-card">
            <h3>Ended Matches</h3>
            <p>{endedMatches}</p>
          </div>
        </div>
  
        {/* ===== SCORE SUMMARY ===== */}
  
        <div
          
        >
          <h3>
            Score Statistics
          </h3>
  
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              marginTop: "10px",
            }}
          >
            {Object.entries(
              scoreStats
            ).map(([score, count]) => (
              <div
                key={score}
                style={{
                  padding: "10px",
                  
                  background: "blue",
                  borderRadius: "8px",
                  fontWeight: "bold",
                }}
              >
                {score} = {count}
              </div>
            ))}
          </div>
        </div>
  
        {loading ? (
    <p>Loading...</p>
  ) : (
    <>
   <div
    key={Date.now()}
    ref={tableRef}
    className="table-wrapper"
  >
        <table>
              <thead>
                <tr>
                  <th>User</th>
                  <th>Bet ID</th>
                  <th>Type</th>
                  <th>Match</th>
                  <th>League</th>
                  <th>Match Date</th>
                  <th>Match Time</th>
                  <th>Match Timestamp</th>
                  <th>Bet Time</th>
                  <th>Score</th>
                  <th>Odds</th>
                  <th>Amount</th>
                  <th>Profit</th>
                  <th>TotalWin</th>
                  <th>Currency</th>
                  <th>Status</th>
                  <th>Payment</th>
                  <th>Match State</th>
                  <th>Actions</th>
                </tr>
              </thead>
  
              <tbody>
                {filtered.length === 0 ? (
                  <tr>
                    <td colSpan="19">
                      No pending bets found
                    </td>
                  </tr>
                ) : (
                  filtered.map((bet) => (
                    <tr key={bet.id}>
                      <td>
                        {bet.username}
                      </td>
  
                      <td>{bet.betId}</td>
  
                      <td>{bet.type}</td>
  
                      <td>
                        {bet.teamA} vs{" "}
                        {bet.teamB}
                      </td>
  
                      <td>{bet.league}</td>
  
                      <td>
                        {bet.matchDate}
                      </td>
  
                      <td>
                        {bet.matchTime}
                      </td>
  
                      <td>
                        {formatDateTime(
                          bet.matchTimestamp
                        )}
                      </td>
  
                      <td>
                        {formatDateTime(
                          bet.createdAt
                        )}
                      </td>
  
                      <td>{bet.score}</td>
  
                      <td>{bet.odds}</td>
  
                      <td>{bet.amount}</td>
  
                      <td>{bet.profit}</td>
  
                      <td>
                        {bet.totalWin}
                      </td>
  
                      <td>
                        {bet.currency}
                      </td>
  
                      <td>{bet.result ? String(bet.result).toUpperCase() : "PENDING"}</td>
  
                      <td>
                        {bet.blockedPayout ? (
                          <span
                            style={{
                              color: "red",
                              fontWeight: "bold",
                            }}
                          >
                            🚫 BLOCKED
                          </span>
                        ) : (
                          <span
                            style={{
                              color: "green",
                              fontWeight: "bold",
                            }}
                          >
                            ✅ ACTIVE
                          </span>
                        )}
                      </td>
  
                      <td>
                        {isPastMatch(bet)
                          ? "ENDED ✅"
                          : "NOT ENDED ⏳"}
                      </td>
  
                      <td
                        style={{
                          display: "flex",
                          gap: "5px",
                          flexWrap: "wrap",
                        }}
                      >
                        <button
    className="won-btn"
    onClick={() => handleWonBet(bet)}
  >
    Won
  </button>
  
  <button
    className="lost-btn"
    onClick={() => handleLost(bet)}
  >
    Lost
  </button>
  
  <button
    className="block-btn"
    onClick={() => toggleBlock(bet)}
  >
    {bet.blockedPayout ? "Unblock" : "Block"}
  </button>
  
  <button
    className="delete-btn"
    onClick={() => deleteBet(bet)}
  >
    Delete
  </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
              </table>
  </div>
  
  <div className="action-buttons">
             <button
    className="won-btn"
    onClick={handleAllWon}
  >
                🟢 All Won
                (Pay Ended Only)
              </button>
  
              <button
    className="lost-btn"
    onClick={handleAllLost}
  >
                🔴 All Lost
                (Ended Only)
              </button>
  
              <button
                className="restore-pending-btn"
                onClick={restoreLostToPending}
              >
                ↩️ Restore LOST to PENDING
              </button>
            </div>
          </>
        )}
      </div>
    );
  }
  
  // Supports both default and named imports in App.js.
  export { AdminViewBetHistory };
  